import type { WasteMovementDirection } from "@/customTypings/wasteMovement/WasteMovement";
import {
    getNewRecordUnsavedChangesCopy,
    type FormikUnsavedChangesCopy,
} from "@/features/unsavedChanges";

export type { FormikUnsavedChangesCopy };

export function wasteMovementDirectionLabel(direction: WasteMovementDirection): string {
    return direction === "Received" ? "Waste Received" : "Waste Removed";
}

/** Modal copy when leaving a new/draft waste movement form with unsaved input. */
export function getWasteMovementNewRecordUnsavedChangesCopy(
    direction: WasteMovementDirection
): FormikUnsavedChangesCopy {
    return getNewRecordUnsavedChangesCopy(wasteMovementDirectionLabel(direction));
}
